<template>
  <div
    class="row column justify-between items-center absolute-full"
    style="background: black"
  >
    <img
      style="height: 6vh; margin: 4vh;"
      :src="currentSite.lightLogoImageUrl"
    >
    <div
      class="absolute-center"
    >
      <div
        class="message text-bold text-white"
        :class="isLoadingMessage ? 'grow' : 'shine'"
        :style="{ 'font-size': isLoadingMessage ? '10vw' : '8vh' }"
      >
        <slot />
        <template v-if="isLoadingMessage">
          <span class="bouncing">.</span>
          <span
            class="bouncing"
            style="animation-delay:0.2s"
          >.</span>
          <span
            class="bouncing"
            style="animation-delay:0.4s"
          >.</span>
        </template>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'WarningMessage',
  configuration: ['currentSite'],
  props: {
    isLoadingMessage: {
      type: Boolean,
      default: false
    }
  }
}

</script>

<style scoped>
.message {
  line-height: 1;
  text-align: center;
  -webkit-box-reflect: below -16px linear-gradient(transparent, rgba(0, 0, 0, 0.2));
}
.grow {
  animation: glow 1.5s infinite alternate;
}
.shine {
  animation: shine 1.5s infinite alternate;
}
.bouncing {
  position: relative;
  display: inline-block;
  animation: bounce .8s infinite;
}
@keyframes glow {
  0%, 100% {
    opacity: 0.8;
    text-shadow: none;
  }
  40% {
    opacity: 1;
    text-shadow: 0 0 10px var(--q-primary),
                 0 0 20px var(--q-primary),
                 0 0 40px var(--q-primary),
                 0 0 80px var(--q-primary),
                 0 0 120px var(--q-primary);
  }
}
@keyframes shine {
  0%, 100% {
    text-shadow: 0 0 15px var(--q-primary),
                 0 0 50px var(--q-primary),
                 0 0 20px var(--q-primary),
                 0 0 40px var(--q-primary),
                 0 0 80px var(--q-primary);
  }
  40% {
    text-shadow: 0 0 10px var(--q-primary),
                 0 0 20px var(--q-primary),
                 0 0 40px var(--q-primary),
                 0 0 80px var(--q-primary),
                 0 0 200px var(--q-primary);
  }
}
@keyframes bounce{
  0%,40%,100% {
    transform: translateY(0);
  }
  20% {
    transform: translateY(-20px);
  }
}

</style>
